import gql from 'graphql-tag'

export const fetchFreeBeerIdsQuery = gql(`
  query ($cartId: String!) {
    getFreeBeerIds(
        cartId: $cartId
    ) {
      freeBeerIds
      freeBeerProductsIds
      freeBeerProducts
    }
  }
  `)
